import type { Routes } from '@angular/router';

import { RoleGuard } from '#core/components/auth/role.guard';
import { MaintenanceGuard, RedirectToProductionGuard } from '#core/maintenance/maintenance.guard';
import { DOWNLOAD_ROUTES } from '#modules/gallery/routes/download.routing';
import { LoggedInLayoutComponent } from '#shell/layouts/logged-in-layout/logged-in-layout.component';
import { HEADER_ONLY_ROUTER_ROUTES } from '#shell/routing/logged-in/header/header.routing';
import { provideLoggedInScope } from '#shell/routing/logged-in/logged-in.providers';
import { SIDENAV_ROUTER_ROUTES } from '#shell/routing/logged-in/sidenav/sidenav.routing';

export const LOGGED_IN_ROUTES: Routes = [
    {
        // MCP OAuth consent screen: behind AuthGuard (login + returnUrl handled by the parent), but outside the app layout.
        path: 'mcp-consent',
        loadComponent: () => import('#modules/mcp-oauth/mcp-consent/mcp-consent.component').then((m) => m.McpConsentComponent),
    },
    {
        path: '',
        component: LoggedInLayoutComponent,
        canActivate: [MaintenanceGuard, RedirectToProductionGuard],
        providers: [provideLoggedInScope(), MaintenanceGuard, RedirectToProductionGuard, RoleGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'restaurants/list',
            },
            {
                path: '',
                loadChildren: () => HEADER_ONLY_ROUTER_ROUTES,
            },
            {
                path: '',
                loadChildren: () => SIDENAV_ROUTER_ROUTES,
            },
            {
                path: 'download',
                loadChildren: () => DOWNLOAD_ROUTES,
            },
        ],
    },
];
